






import Vue from 'vue'
import gql from '@/gqlService.coffee'
import moment from "moment"

Vue.filter 'default', (value, default_value)->
    if !value?
        return default_value
    else
        return value

Vue.filter("from_now", (value)->
    return moment(value).fromNow()
)

export default {
    name: 'App',
    props: {
       msg: String
    },
    methods: {}
    mounted: ()->
        self = @
        self.$djangows['onmodelsignals']({"modelName": "alert", "appLabel": "consultant"}, (event)->
            console.log("state event", event)
            if event.obj?
                if event.signal_type != "post_delete"
                    if event.obj.read == false
                        self.$store.dispatch("notify", {"level": event.obj.level, "text": event.obj.text, "seconds": event.obj.seconds})
        )
}
